module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-10"
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Bank Soal'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-9"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "d-flex align-center gap-15"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/img/icon_file.svg'),
      "contain": "",
      "width": 50,
      "height": 50
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-weight-500"
  }, [_vm._v("\n                                    Total Soal\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 primary--text mt-1",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.formatNumber(
    _vm.total_data.total_item
  ) || 0) + "\n                                    "), _c('span', {
    staticClass: "font-size-14"
  }, [_vm._v(" Soal ")])])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "d-flex align-center gap-15"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/img/icon_file_validated.svg'),
      "contain": "",
      "width": 50,
      "height": 50
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-weight-500"
  }, [_vm._v("\n                                    Total Soal Tervalidasi\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 success--text mt-1",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.formatNumber(
    _vm.total_data.total_item_valid
  ) || 0) + "\n                                    "), _c('span', {
    staticClass: "font-size-14"
  }, [_vm._v(" Soal ")])])])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticClass: "d-flex align-center justify-space-between px-3 pt-3 font-weight-600 font-size-18 border-bottom pb-3 mt-5"
  }, [_c('div', [_vm._v("Daftar Bank Soal")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "depressed": "",
      "dark": "",
      "color": "#42b873"
    },
    on: {
      "click": function($event) {
        return _vm.onSearchData()
      }
    }
  }, [_vm._v("\n                Refresh\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "dark": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/item-form?mapel=1')
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Soal\n            ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "px-3 py-2 mb-5"
  }, [_c('div', {
    staticClass: "mt-5"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": 3
    }
  }, [_c('v-select', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Pilih Mata Pelajaran",
      "dense": "",
      "outlined": "",
      "clearable": "",
      "items": _vm.mapelList,
      "item-text": "nama",
      "item-value": "id"
    },
    model: {
      value: (_vm.mapel_id),
      callback: function($$v) {
        _vm.mapel_id = $$v
      },
      expression: "mapel_id"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0 py-3 border-top-1"
  }, [_c('div', {
    staticClass: "font-weight-600 px-3 font-size-16"
  }, [_vm._v("Filter")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    staticClass: "no-gutters gap-10"
  }, [_c('v-col', [_c('v-autocomplete', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Bab",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": _vm.list_bab,
      "item-text": "bab_name",
      "item-value": "bab_name"
    },
    model: {
      value: (_vm.bab),
      callback: function($$v) {
        _vm.bab = $$v
      },
      expression: "bab"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Sub Bab",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": _vm.list_sub_bab,
      "item-text": "sub_bab_name",
      "item-value": "sub_bab_name"
    },
    model: {
      value: (_vm.subbab),
      callback: function($$v) {
        _vm.subbab = $$v
      },
      expression: "subbab"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "id": "datatable_sort",
      "height": "36px",
      "hide-details": "",
      "placeholder": "Sub Sub Bab",
      "clearable": "",
      "dense": "",
      "outlined": "",
      "items": _vm.list_sub_sub_bab,
      "item-text": "sub_sub_bab_name",
      "item-value": "sub_sub_bab_name"
    },
    on: {
      "change": function($event) {
        return _vm.onSearchData()
      }
    },
    model: {
      value: (_vm.subsubbab),
      callback: function($$v) {
        _vm.subsubbab = $$v
      },
      expression: "subsubbab"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-select', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Status Soal",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": [{
          text: 'Valid',
          value: true
        },
        {
          text: 'Belum Valid',
          value: false
        } ],
      "item-text": "text",
      "item-value": "value"
    },
    on: {
      "change": function($event) {
        return _vm.onSearchData()
      }
    },
    model: {
      value: (_vm.is_valid_filter),
      callback: function($$v) {
        _vm.is_valid_filter = $$v
      },
      expression: "is_valid_filter"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-select', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Urutkan Soal",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": [{
          text: 'Baru ke Lama',
          value: 'desc'
        },
        {
          text: 'Lama ke Baru',
          value: 'asc'
        } ],
      "item-text": "text",
      "item-value": "value"
    },
    on: {
      "change": function($event) {
        return _vm.onSearchData()
      }
    },
    model: {
      value: (_vm.sort_type),
      callback: function($$v) {
        _vm.sort_type = $$v
      },
      expression: "sort_type"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "px-3 pt-3 pb-4 border-top-1 border-bottom"
  }, [_c('div', {
    staticClass: "d-flex gap-10"
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Ketik kode soal dan tekan enter",
      "dense": "",
      "outlined": "",
      "small": "",
      "hide-details": "",
      "append-icon": "mdi-magnify"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearchData()
      }
    },
    model: {
      value: (_vm.item_code),
      callback: function($$v) {
        _vm.item_code = $$v
      },
      expression: "item_code"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "blew",
      "depressed": "",
      "height": "2.8em"
    },
    on: {
      "click": function($event) {
        _vm.dialogAdvanceFilter = true
      }
    }
  }, [_vm._v("\n                    Advance Filter\n                ")])], 1), _vm._v(" "), (_vm.advance_filter.length) ? _c('div', {
    staticClass: "mt-5 pt-3"
  }, _vm._l((_vm.advance_filter), function(data, i) {
    return _c('v-chip', {
      key: i,
      staticClass: "mr-2 custom-chip-close",
      attrs: {
        "close": "",
        "color": "#f3f5f7"
      },
      on: {
        "click:close": function($event) {
          return _vm.removeFilter(i, data)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.filter_name) + " :\n                    "), (data.filter === 'is_pembahasan') ? _c('span', [_vm._v("\n                        " + _vm._s(data.value === "true" ? "Ada" : "Tidak Ada") + "\n                    ")]) : _c('span', [_vm._v("\n                        " + _vm._s(data.value) + "\n                    ")])])
  }), 1) : _vm._e()]), _vm._v(" "), _c('v-data-table', {
    staticClass: "mb-8",
    attrs: {
      "single-select": "",
      "item-key": "kode",
      "headers": _vm.headers,
      "items": _vm.data,
      "server-items-length": _vm.totalItems,
      "items-per-page": _vm.itemsPerPage,
      "page": _vm.page,
      "footer-props": {
        'items-per-page-options': [10, 20, 50, 100, 500, 1000],
      },
      "no-data-text": "Data itembank tidak tersedia"
    },
    on: {
      "update:page": [function($event) {
        _vm.page = $event
      }, _vm.onSearchData],
      "click:row": _vm.rowClick,
      "update:items-per-page": _vm.onUpdatePerPages
    },
    scopedSlots: _vm._u([{
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-menu', {
          attrs: {
            "offset-y": "",
            "transition": "slide-y-transition"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                attrs: {
                  "text": ""
                }
              }, on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', [_c('v-list', {
          staticStyle: {
            "width": "180px"
          }
        }, [_c('v-list-item-group', [_c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.getDetailSoal(item)
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center gap-10"
        }, [_c('v-icon', {
          staticClass: "menu-icon",
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("\n                                            mdi-file-document-outline\n                                        ")]), _vm._v("\n\n                                        Detail\n                                    ")], 1)], 1), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.getPreview(item)
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center gap-10"
        }, [_c('v-icon', {
          staticClass: "menu-icon",
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("\n                                            mdi-cellphone\n                                        ")]), _vm._v("\n\n                                        Preview\n                                    ")], 1)], 1), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.editSoal(item)
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center gap-10"
        }, [_c('v-icon', {
          staticClass: "menu-icon",
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("\n                                            mdi-pencil-outline\n                                        ")]), _vm._v("\n\n                                        Edit\n                                    ")], 1)], 1), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.editSoalNewTab(item)
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center gap-10"
        }, [_c('v-icon', {
          staticClass: "menu-icon",
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("\n                                            mdi-pencil-box-outline\n                                        ")]), _vm._v("\n\n                                        Edit New Tab\n                                    ")], 1)], 1), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.confirmDelete(item)
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center gap-10"
        }, [_c('v-icon', {
          staticClass: "menu-icon",
          attrs: {
            "color": "red"
          }
        }, [_vm._v("\n                                            mdi-delete-outline\n                                        ")]), _vm._v("\n\n                                        Hapus\n                                    ")], 1)], 1)], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "item.no",
      fn: function(ref) {
        var index = ref.index;

        return [_vm._v("\n                " + _vm._s((_vm.page - 1) * _vm.itemsPerPage + index + 1) + "\n            ")]
      }
    }, {
      key: "item.sub_bab",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                " + _vm._s(item.sub_bab ? item.sub_bab.nama : "-") + "\n            ")]
      }
    }, {
      key: "item.sub_sub_bab",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                " + _vm._s(item.sub_sub_bab ? item.sub_sub_bab.nama : "-") + "\n            ")]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [(item.is_new) ? _c('v-chip', {
          staticClass: "font-weight-600 pa-3 mb-2 mr-1",
          attrs: {
            "x-small": "",
            "color": "#e2f5ea",
            "text-color": "#27ae60"
          }
        }, [_vm._v("\n                        New\n                    ")]) : _vm._e(), _vm._v(" "), (item.is_valid) ? _c('v-chip', {
          staticClass: "font-weight-600 pa-3 mb-2",
          attrs: {
            "x-small": "",
            "color": "#e2f5ea",
            "text-color": "#27ae60"
          }
        }, [_vm._v("\n                        Valid\n                    ")]) : _vm._e(), _vm._v(" "), (!item.is_valid) ? _c('v-chip', {
          staticClass: "font-weight-600 pa-3 mb-2",
          attrs: {
            "x-small": "",
            "color": "#f0f3f9",
            "text-color": "#5e718d"
          }
        }, [_vm._v("\n                        Belum Valid\n                    ")]) : _vm._e()], 1)]
      }
    }, {
      key: "item.grades",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                " + _vm._s(item.grades
          .map(function (e) { return e.grade; })
          .sort(function (a, b) { return a - b; })
          .join(", ")) + "\n            ")]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('p', {
          staticClass: "my-2"
        }, [_vm._v("Hasil pencarian tidak ditemukan.")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.datatable),
      callback: function($$v) {
        _vm.datatable = $$v
      },
      expression: "datatable"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center gap-10 select-page"
  }, [_c('div', {
    staticClass: "select-title"
  }, [_vm._v("Select Page :")]), _vm._v(" "), _c('div', {
    staticClass: "select-form"
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "maxlength": "7",
      "items": _vm.pageItems
    },
    on: {
      "change": _vm.onSearchPagingData
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)]), _vm._v(" "), (_vm.showDetails.open) ? _c('v-dialog', {
    attrs: {
      "width": "550px",
      "min-height": "537px",
      "max-height": "771px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.showDetails.open = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('detail', {
          attrs: {
            "details": _vm.details
          },
          on: {
            "close": function($event) {
              _vm.showDetails.open = false
            },
            "preview": function($event) {
              _vm.getPreview(_vm.showDetails.function);
              _vm.showDetails.open = false;
            }
          }
        })]
      }
    }], null, false, 841662561),
    model: {
      value: (_vm.showDetails.open),
      callback: function($$v) {
        _vm.$set(_vm.showDetails, "open", $$v)
      },
      expression: "showDetails.open"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300px",
      "min-height": "537px",
      "max-height": "771px",
      "content-class": "elevation-0",
      "elevation": "0",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.showModal.open = false
      }
    },
    model: {
      value: (_vm.showModal.open),
      callback: function($$v) {
        _vm.$set(_vm.showModal, "open", $$v)
      },
      expression: "showModal.open"
    }
  }, [(_vm.showModal.open) ? _c('preview', {
    attrs: {
      "preview": _vm.preview,
      "loading": _vm.loading_preview
    },
    on: {
      "close": function($event) {
        _vm.showModal.open = false
      },
      "validate": function($event) {
        return _vm.validateItem(_vm.showModal.function)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "700"
    },
    model: {
      value: (_vm.dialogAdvanceFilter),
      callback: function($$v) {
        _vm.dialogAdvanceFilter = $$v
      },
      expression: "dialogAdvanceFilter"
    }
  }, [_c('dialog-advance-filter', {
    on: {
      "close": function($event) {
        _vm.dialogAdvanceFilter = false
      },
      "filter": function($event) {
        return _vm.onAdvanceFilter($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('dialog-confirm', {
    attrs: {
      "title": _vm.dialogConfirm.title,
      "subtitle": _vm.dialogConfirm.subtitle
    },
    on: {
      "close": function($event) {
        _vm.dialogConfirm.open = false
      },
      "confirm": function($event) {
        _vm.deleteSoal(_vm.dialogConfirm.function);
        _vm.dialogConfirm.open = false;
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex mb-1"
  }, [_c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Bank Soal")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e0957a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/itembank/components/ItemBank.vue
// module id = 1539
// module chunks = 1